// extracted by mini-css-extract-plugin
export var circle = "_1g-2";
export var icon = "_1g-a";
export var iconHighlight = "_1g-0";
export var lg = "_1g-8";
export var md = "_1g-7";
export var outline = "_1g-4";
export var sm = "_1g-6";
export var square = "_1g-1";
export var xl = "_1g-9";
export var xs = "_1g-5";
export var xxs = "_1g-3";